"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeFocusOnMouseUp;
// Remove focus ring after clicking, but not when keyboard tabbing around
function removeFocusOnMouseUp(event) {
  // This event takes too long, and prevents onClick occasionally.
  // And we do not need to do it syncronously.
  const {
    currentTarget,
    target
  } = event;
  window.setTimeout(() => (currentTarget || target).blur(), 0);
}